<template>
	<app-content style="position: relative;">
		<div class="mask" v-if="User.role =='View' || form.auditMemberId"></div>
		<div class="h-panel" style="width: 1000px;margin: 0 auto;padding-top: 20px;">
			<img v-if="form.auditMemberId" class="auditpic" src="@/assets/audit.png" alt="已审核">
			<div class="padding-right-left">
				<Row type="flex" :space-x="10">
					<Cell v-if="User.role !='View'">
						<template v-if="isCheck">
							<Button v-if="isCheck" @click="$router.back()">返回</Button>
							<Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading">保存</Button>
						</template>
						<template v-else>
							<Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
							<Button :disabled="!!form.auditMemberId" color="primary" @click="toNew()" v-else>新增</Button>
							<Button :disabled="!canSave || !!form.auditMemberId" color="primary" @click="save(false)" :loading="loading">保存</Button>
							<template v-if="form.id && currentAccountSets.voucherReviewed">
								<Button v-if="form.auditMemberId" color="primary" @click="cancelAudit" :loading="loading">取消审核</Button>
								<Button v-else color="primary" @click="audit" :loading="loading">审核</Button>
							</template>
							<Button size="s" @click="openTemplateSave" :disabled="!canSave">存为模板</Button>
							<Button size="s" @click="openTemplateImport">模板导入</Button>
						</template>
					</Cell>
					<Cell v-if="!isCheck">
						<a class="h-btn" :href="`/api/pfd/voucher?id=${form.id}`" target="_blank">打印</a>
					</Cell>
					<Cell :flex="1" class="text-right" v-if="!isCheck">
						<span class="shortcut-hint" @mouseenter="shortcutHint = true" @mouseleave="shortcutHint = false">
							快捷键<i class="fa fa-question-circle"></i>
							<div class="shortcut-pop" v-if="shortcutHint">
								<img :src="shortcutImg" alt="金蝶快捷键">
								<div class="shortcut-note">已实现：Ctrl+S 保存 ｜ F12 保存并新增 ｜ F4 新增一行 ｜ F7 打开科目 ｜ Ctrl+L 模板导入 ｜ PageUp/PageDown 上一条/下一条 ｜ Shift+Enter/Shift+Tab 上一输入框 ｜ Tab·Enter 下一输入框 ｜ = 或 + 自动平衡 ｜ 空格 借贷互换 ｜ Y 携带科目余额 ｜ 小键盘 //·. 复制摘要</div>
							</div>
						</span>
						<ButtonGroup>
							<Button :loading="loading" @click="before" size="s" v-tooltip content="上一条" icon="h-icon-left"></Button>
							<Button :loading="loading" @click="next" size="s" v-tooltip content="下一条" icon="h-icon-right"></Button>
						</ButtonGroup>
					</Cell>
				</Row>
				<Row class="margin-top" type="flex" :space-x="10">
					<Cell>
						<Select @change="loadCode" keyName="word" titleName="word" style="min-width: 70px" :deletable="false" :datas="voucherWords" v-model="form.word" placeholder="记"/>
					</Cell>
					<Cell class="label">
						<NumberInput :min="1" v-model="form.code" v-width="90" style="display: inline-block"/>
						号
					</Cell>
					<Cell class="label">
						日期：
					</Cell>
					<Cell class="label">
						<DatePicker :disabled="!!carryForward" :option="dpOps" :clearable="false" v-model="form.voucherDate" format="YYYY-MM-DD"/>
					</Cell>
					<Cell class="label">
						<DropdownCustom :toggle-icon="false" class-name="h-text-dropdown">
							<span class="text-hover blue-color font-bold">备注</span>
							<div slot="content" v-width="200">
								<textarea placeholder="请输入备注内容" v-model="form.remark" v-autosize rows="3" style="width: 100%;"></textarea>
							</div>
						</DropdownCustom>
					</Cell>
				</Row>
			</div>
			<voucher-table ref="voucherTable" v-model="voucherTable" @jump-to-header="focusHeaderDate"/>
			<div class="padding-right-left margin-top">
				<voucher-attachment v-if="form.id" :voucher-id="form.id"/>
				<voucher-attachment v-else :temp-id="tempId"/>
			</div>
			<div class="padding-right-left padding-bottom">
				制单人：{{User.realName}}
			</div>
			<Modal v-model="templateVisible" hasCloseIcon hasDivider :closeOnMask="true" title="凭证模板">
				<template v-if="!templateSaving">
					<div class="template-toolbar">
						<Button color="primary" size="s" @click="openTemplateSave">将当前凭证存为模板</Button>
						<Button size="s" @click="loadTemplates">刷新</Button>
					</div>
					<div class="template-empty" v-if="!templates.length">暂无模板，可先点击「存为模板」</div>
					<ul class="template-list" v-else>
						<li v-for="t in templates" :key="t.id">
							<span class="t-name">{{t.name}}</span>
							<span class="t-amt">借 {{numText(t.debitAmount)}} / 贷 {{numText(t.creditAmount)}}</span>
							<Button size="s" color="primary" @click="importTemplate(t)">导入</Button>
							<Button size="s" @click="deleteTemplate(t)">删除</Button>
						</li>
					</ul>
				</template>
				<template v-else>
					<p class="template-save-tip">为当前凭证命名后保存为常用模板（含科目与借贷金额）</p>
					<input class="h-input" v-model="templateName" placeholder="请输入模板名称" @keydown.enter="doSaveTemplate">
					<div class="text-right margin-top">
						<Button @click="templateSaving=false">取消</Button>
						<Button color="primary" :loading="loading" @click="doSaveTemplate">保存</Button>
					</div>
				</template>
			</Modal>
		</div>
	</app-content>
</template>

<script>
	import VoucherTable from "../../components/VoucherTable";
	import {mapState} from 'vuex';
	import moment from 'moment';
	import jQuery from 'jquery';
	import shortcutImg from '@/assets/shortcut-kingdee.png';

	export default {
		name: "VoucherForm",
		components: {VoucherTable},
		inject: ['reload'],
		props: {
			voucherId: [Number, String],
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			voucherItems() {
				return this.voucherTable.voucherItems;
			},
			canSave() {
				return this.voucherItems.length > 0
			},
			isCheck() {
				return !!this.$route.params.checkData
			}
		},
		data() {
			return {
				loading: false,
				carryForward: false,
				voucherWords: [],
				voucherTable: {voucherItems: []},
				dpOps: {
					start: moment().toDate()
				},
				voucher: {},
				tempId: '',
				templateVisible: false,
				templates: [],
				templateName: '',
				templateSaving: false,
				shortcutHint: false,
				shortcutImg: shortcutImg,
				form: {
					remark: '',
					word: '',
					code: '',
					voucherDate: '',
					carryForward: false,
				}
			}
		},
		watch: {
			'form.word'(val, old) {
				if (!old && this.voucherId) {
					return;
				}
				val && this.loadCode();
			},
			voucherId(val) {
				if (!val) {
					this.reload()
				} else {
					this.init();
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			// 未保存就离开时清理草稿附件
			if (!this.form.id && this.tempId) {
				this.$api.voucher.deleteAttachmentPending(this.tempId);
			}
			next();
		},
		beforeDestroy() {
			window.removeEventListener('keydown', this.shortcutHandler);
		},
		methods: {
			loadVoucherWords() {
				this.$api.setting.voucherWord.list().then(({data}) => {
					this.voucherWords = data || [];
					this.form.word = data.find(value => value.isDefault).word
				})
			},
			loadCode() {
				this.$api.voucher.loadCode({
					word: this.form.word,
					currentAccountDate: this.form.voucherDate
				}).then(({data}) => {
					this.form.code = data
				})
			},
			toNew() {
				this.$router.push({name: 'VoucherForm'});
			},
			save(next) {
				if (!this.form.code) {
					this.$Message("亲，请输入编号！");
					return
				}

				if (!this.voucherItems.length) {
					this.$Message("亲，第1行不能为空！");
					return
				}

				if (this.checkItem("摘要", 'summary') || this.checkItem("科目", 'subjectId') || this.checkItem("金额")) {
					return
				}

				if (this.voucherTable.jfTotal != this.voucherTable.dfTotal) {
					this.$Message("亲，借贷不平衡！");
					return
				}

				this.loading = true;
				this.$api.voucher[this.voucherId ? 'update' : 'save'](Object.assign({}, this.form, {details: this.voucherItems, createMember: this.User.id, tempId: this.form.id ? '' : this.tempId})).then(({success, data}) => {
					if (success && !this.form.id) {
						if (next) {
							if (!this.isCheck) {
								this.reload();
							} else {
								this.$router.back();
							}
						} else {
							this.$router.push({name: 'VoucherForm', params: {voucherId: data.id}});
						}
					}

					this.loading = false;
					this.$Message("亲，保存成功！");

					//如果是结转凭证就返回
					if (this.$route.params.checkData) {
						this.$router.back();
					}
				}).catch(() => {
					this.loading = false;
				});
			},
			checkItem(name, field) {
				let i = 0, len = this.voucherItems.length, row = -1;
				for (; i < len; i++) {
					if ((field && !this.voucherItems[i][field]) || (!field && !this.voucherItems[i].debitAmount && !this.voucherItems[i].creditAmount)) {
						row = i + 1;
						break;
					}
				}

				if (row > -1) {
					this.$Message(`亲，第${row}行，请输入${name}！`);
					return true;
				}
			},
			before() {
				this.loading = true;
				this.$api.voucher.beforeId({currentId: this.voucherId}).then(({data}) => {
					if (data) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data}})
					} else {
						this.$Message("亲，已经没有上一条啦！")
					}
				}).finally(() => {
					this.loading = false;
				});
			},
			next() {
				this.loading = true;
				this.$api.voucher.nextId({currentId: this.voucherId}).then(({data}) => {
					if (data) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data}})
					} else {
						this.$Message("亲，已经没有下一条啦！")
					}
				}).finally(() => {
					this.loading = false;
				});
			},
			init() {
				if (this.voucherId) {
					this.$api.voucher.load(this.voucherId).then(({data}) => {
						this.$refs.voucherTable.initValue(data.details);
						this.voucher = data;
						this.form = {
							id: data.id,
							auditMemberId: data.auditMemberId,
							word: data.word,
							remark: data.remark,
							voucherDate: data.voucherDate,
							carryForward: data.carryForward,
							code: data.code
						};
					})
				} else {
					this.form.voucherDate = moment(this.currentAccountSets.currentAccountDate).endOf('month').format('YYYY-MM-DD');
				}

				//结转凭证初始化
				let params = this.$route.params;
				if (params.checkData) {
					this.carryForward = !!params.type.code;
					this.form.voucherDate = moment(params.checkData.checkYear + "-" + params.checkData.checkMonth).endOf('month').format('YYYY-MM-DD');
					let {subject, name} = params.type;

					let details = [];
					this.$api.setting.subject.loadByCode(subject, Object.assign(params.checkData, {name})).then(({data}) => {
						let creditAmount = 0, debitAmount = 0;
						data.subject.forEach(sub => {
							let amount = data.amount[sub.code];
							let detail = {
								summary: `第${params.checkData.checkMonth}期 ${name}`,
								subject: sub,
								subjectId: sub.id,
								subjectName: `${sub.code}-${sub.name}`,
								subjectCode: sub.code
							};
							if (amount) {
								if (amount.creditAmount) {
									details.push(Object.assign({}, detail, {[name === '结转损益' ? 'debitAmount' : 'creditAmount']: amount.creditAmount}));
									creditAmount += amount.creditAmount;
								}

								if (amount.debitAmount) {
									details.push(Object.assign({}, detail, {[name === '结转损益' ? 'creditAmount' : 'debitAmount']: amount.debitAmount}));
									debitAmount += amount.debitAmount;
								}
							} else if (name !== '结转损益' || sub.name === '本年利润') {
								details.push(detail);
							}
						});

						if (name === '结转损益') {
							this.form.carryForward = true;
							details.forEach((value, index) => {
								if (value.subject.name === '本年利润') {
									delete value.debitAmount;
									let amount = debitAmount - creditAmount;
									if (amount > 0) {
										value.debitAmount = amount;
									} else {
										value.creditAmount = Math.abs(amount);
									}
								}
							});
						}

						this.$refs.voucherTable.initValue(details);
					});
				}
				this.loadVoucherWords();
			},
			audit() {
				this.$Confirm("亲，确认要审核吗?").then(() => {
					this.loading = true;
					this.$api.voucher.audit({checked: [this.voucher.id], year: this.voucher.voucherYear, month: this.voucher.voucherMonth}).then(() => {
						this.reload();
						this.$Message("审核成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			cancelAudit() {
				this.$Confirm("亲，确认要取消审核吗?").then(() => {
					this.loading = true;
					this.$api.voucher.cancelAudit({checked: [this.voucher.id], year: this.voucher.voucherYear, month: this.voucher.voucherMonth}).then(() => {
						this.reload();
						this.$Message("取消审核成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			shortcutHandler(e) {
				if (this.isCheck || this.User.role === 'View') {
					return;
				}
				// 弹窗打开时不响应表单快捷键
				if (jQuery('.h-modal:visible').length) {
					return;
				}
				let key = e.key || '';
				let k = key.toLowerCase();
				if (e.ctrlKey && k === 's') {
					e.preventDefault();
					this.save(false);
					return;
				}
				if (key === 'F12') {
					e.preventDefault();
					this.save(true);
					return;
				}
				if (key === 'F4') {
					e.preventDefault();
					if (this.$refs.voucherTable) {
						this.$refs.voucherTable.insertRowAfterCurrent();
					}
					return;
				}
				if (key === 'F7') {
					e.preventDefault();
					if (this.$refs.voucherTable) {
						this.$refs.voucherTable.focusSubject();
					}
					return;
				}
				if (e.ctrlKey && k === 'l') {
					e.preventDefault();
					this.openTemplateImport();
					return;
				}
				if (key === 'PageUp' && this.voucherId) {
					e.preventDefault();
					this.before();
					return;
				}
				if (key === 'PageDown' && this.voucherId) {
					e.preventDefault();
					this.next();
					return;
				}
				// 单据头日期输入按 Tab 跳入分录首格
				if (key === 'Tab' && !e.shiftKey && !this.isInsideTable(e.target) && e.target.closest && e.target.closest('.h-datetime')) {
					e.preventDefault();
					if (this.$refs.voucherTable) {
						this.$refs.voucherTable.focusFirstCell();
					}
				}
			},
			isInsideTable(target) {
				return target && target.closest && !!target.closest('.voucher-table');
			},
			focusHeaderDate() {
				let input = jQuery('.h-datetime input');
				if (input.length) {
					input.focus();
				}
			},
			numText(num) {
				if (num === null || num === undefined || num === '') {
					return '0.00';
				}
				return Number(num).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2});
			},
			loadTemplates() {
				this.$api.voucher.voucherTemplate.list().then(({data}) => {
					this.templates = data || [];
				});
			},
			openTemplateImport() {
				this.loadTemplates();
				this.templateSaving = false;
				this.templateVisible = true;
			},
			openTemplateSave() {
				this.templateName = '';
				this.templateSaving = true;
				this.templateVisible = true;
			},
			doSaveTemplate() {
				if (!this.templateName.trim()) {
					this.$Message("亲，请输入模板名称！");
					return;
				}
				let items = this.voucherItems.filter(v => v.subjectId);
				if (!items.length) {
					this.$Message("亲，至少有一行科目才能存为模板！");
					return;
				}
				let payload = {
					name: this.templateName.trim(),
					type: 0,
					isDefault: false,
					details: items.map(v => ({
						summary: v.summary,
						subjectId: v.subjectId,
						subjectName: v.subjectName,
						subjectCode: v.subjectCode,
						debitAmount: v.debitAmount,
						creditAmount: v.creditAmount,
						auxiliaryTitle: v.auxiliaryTitle || ''
					}))
				};
				this.$api.voucher.voucherTemplate.save(payload).then(() => {
					this.$Message("亲，模板保存成功！");
					this.templateSaving = false;
					this.loadTemplates();
				});
			},
			importTemplate(t) {
				if (!t.details || !t.details.length) {
					this.$Message("亲，该模板没有分录！");
					return;
				}
				let select = (this.$refs.voucherTable && this.$refs.voucherTable.voucherSelect) || [];
				let rows = t.details.map(d => {
					let sub = select.find(s => s.id === d.subjectId) || (d.subjectCode ? select.find(s => s.code === d.subjectCode) : null);
					return {
						summary: d.summary,
						subjectId: d.subjectId,
						subjectName: d.subjectName,
						subjectCode: d.subjectCode,
						debitAmount: d.debitAmount,
						creditAmount: d.creditAmount,
						auxiliaryTitle: d.auxiliaryTitle || '',
						subject: sub || null
					};
				});
				this.$refs.voucherTable.initValue(rows);
				this.templateVisible = false;
				this.$Message("亲，模板已导入，请核对后保存！");
			},
			deleteTemplate(t) {
				this.$Confirm(`亲，确认删除模板「${t.name}」吗？`).then(() => {
					this.$api.voucher.voucherTemplate.delete(t.id).then(() => {
						this.$Message("亲，模板已删除！");
						this.loadTemplates();
					});
				});
			}
		},
		mounted() {
			this.$set(this.dpOps, "start", moment(this.currentAccountSets.enableDate).toDate());
			this.tempId = 't' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
			window.addEventListener('keydown', this.shortcutHandler);
			this.init();
		}
	}
</script>

<style scoped>
	.mask {
		position: absolute;
		height: 100%;
		width: 100%;
		z-index: 100;
		bottom: 0;
		top: 110px;
	}

	.auditpic {
		position: absolute;
		z-index: 100;
		right: 100px;
	}

	.att-hint {
		color: @gray2-color;
		font-size: 13px;
	}

	.shortcut-hint {
		position: relative;
		display: inline-block;
		margin-right: 12px;
		cursor: help;
		color: @primary-color;

		.fa {
			margin-left: 2px;
		}

		.shortcut-pop {
			position: absolute;
			right: 0;
			top: 100%;
			z-index: 999;
			width: 340px;
			background: #fff;
			border: 1px solid @border-color;
			border-radius: @border-radius;
			box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
			padding: 10px;

			.shortcut-note {
				margin-top: 8px;
				font-size: 11px;
				line-height: 1.7;
				color: @gray2-color;
			}
		}
	}

	.template-toolbar {
		margin-bottom: 10px;
	}

	.template-empty {
		color: @gray2-color;
		text-align: center;
		padding: 20px 0;
	}

	.template-save-tip {
		color: @gray2-color;
		margin-bottom: 8px;
	}

	.template-list {
		list-style: none;
		margin: 0;
		padding: 0;

		li {
			display: flex;
			align-items: center;
			padding: 8px 4px;
			border-bottom: 1px dashed @border-color;

			&:last-child {
				border-bottom: none;
			}

			.t-name {
				flex: 1;
				font-weight: bold;
				color: @dark2-color;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.t-amt {
				color: @gray2-color;
				font-size: 12px;
				margin: 0 10px;
				white-space: nowrap;
			}
		}
	}
</style>
